import type React from 'react';
import { Skeleton } from '@heroui/react';
import { getNodeTestProps } from '@/utils';

const PLACEHOLDER_ROW_COUNT = 6;

/**
 * Loading placeholder for the transactions list. Self-served: the section shows
 * this while the day's query is in flight, so the page needs no skeleton of its
 * own.
 */
export const TransactionsListSkeleton: React.FC = () => (
    <div
        aria-busy
        className="flex flex-col gap-2"
        {...getNodeTestProps('transactions-list-skeleton')}
    >
        <Skeleton className="h-4 w-28 rounded-md" />
        <div className="divide-y divide-border overflow-hidden rounded-2xl border border-border bg-surface">
            {Array.from({ length: PLACEHOLDER_ROW_COUNT }).map((_, index) => (
                <div
                    className="flex items-center justify-between gap-4 px-4 py-3"
                    // Fixed-count placeholder rows, never reordered.
                    key={index}
                >
                    <div className="flex flex-col gap-1.5">
                        <Skeleton className="h-3 w-32 rounded-md" />
                        <Skeleton className="h-3 w-24 rounded-md" />
                    </div>
                    <div className="flex items-center gap-4">
                        <Skeleton className="hidden h-3 w-16 rounded-md sm:block" />
                        <Skeleton className="h-4 w-16 rounded-md" />
                        <Skeleton className="h-5 w-14 rounded-full" />
                    </div>
                </div>
            ))}
        </div>
    </div>
);
